import { render, staticRenderFns } from "./StreamPlayer.vue?vue&type=template&id=1318ba59&scoped=true&"
import script from "./StreamPlayer.vue?vue&type=script&lang=js&"
export * from "./StreamPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318ba59",
  null
  
)

export default component.exports